import { VERSION, REVISION } from "../consts/version";
import { ResizeSensor } from "css-element-queries";

let pageOffset = 400;
if (header_offset_scroll) {
  pageOffset = header_offset_scroll;
}

$(function () {
  $(window).on("load", function () {
    //Version set start
    $("#version-number").html(`v${VERSION} (${REVISION})`);
    //Version set end

    $(".js-popup-search .popup-search").css(
      "top",
      $(".header-wrapper").outerHeight() + "px"
    );

    $(".js-popup-search .popup-search").css(
      "transform",
      $(".header-wrapper").css("transform")
    );

    $(".lazy").Lazy({
      scrollDirection: "vertical",
      effect: "fadeIn",
      visibleOnly: true,
      onError: function (element) {
        // console.log("error loading " + element.data("src"));
        return;
      },
    });
  });

  $(window).on("resize", function () {
    // if(!haveOverlay)
    // $(".wrapper").css("padding-top", `${$(".header-wrapper").outerHeight()}px`);

    if ($(window).width() > 1023 && $("#header").hasClass("is-active")) {
      $("body").removeClass("is-fixed");
      $("#header").removeClass("is-active");
      $(".mobile-nav.js-mobile-nav").removeClass("mobile-nav--active");
    }
  });
});
